export default "__VITE_ASSET__CKpkoN_w__"